(function(){'use strict';
function init(root){
 var form=root.querySelector('[data-dhc-tracking-form]');
 var box=root.querySelector('[data-dhc-tracking-result]');
 if(!form||!box||form.dataset.dhcReady)return;
 form.dataset.dhcReady='1';
 var input=form.querySelector('[name="tracking_number"]');
 var submit=form.querySelector('button[type="submit"]');
 var trackingApiUrl=(root.getAttribute("data-dhc-tracking-api")||"").trim();
 var dhc17TrackPromise=null;
 var dhc17TrackSeq=0;

 function el(tag,cls,text){
  var x=document.createElement(tag);
  if(cls)x.className=cls;
  if(text!==undefined)x.textContent=String(text);
  return x;
 }
 function link(text,url,external){
  var a=el('a','dhc-tracking-link',text);
  a.href=url;
  if(external){a.target='_blank';a.rel='noopener noreferrer';}
  return a;
 }
 function date(v){
  if(!v)return '';
  var d=new Date(v);
  return isNaN(d.getTime())?'':new Intl.DateTimeFormat('en-US',{dateStyle:'medium',timeStyle:'short'}).format(d);
 }
 function safeExternal(value){
  try{
   var u=new URL(value,location.origin);
   if(u.protocol!=='https:'||u.username||u.password)return '';
   var h=u.hostname.toLowerCase();
   var ok=/^(?:[a-z0-9-]+\.)*(?:cainiao\.com|yuntrack\.com|yunexpress\.com|ups\.com|usps\.com|fedex\.com|dhl\.com|cjpacket\.com|4px\.com|speedx\.io|uniuni\.com|gofoexpress\.com|canadapost-postescanada\.ca|royalmail\.com|auspost\.com\.au)$/.test(h);
   return ok?u.href:'';
  }catch(e){return '';}
 }
 function identify(n){
  var u=n.toUpperCase();
  if(/^CNG[A-Z0-9-]{5,}$/.test(u)){
   return {name:'Cainiao',detail:'Cainiao shipment',url:'https://global.cainiao.com/newDetail.htm?mailNoList='+encodeURIComponent(n)+'&otherMailNoList='};
  }
  if(/^YT[A-Z0-9-]{8,}$/.test(u)){
   return {name:'YunExpress',detail:'YunExpress shipment',url:'https://www.yuntrack.com/parcelTracking?id='+encodeURIComponent(n)};
  }
  if(/^1Z[A-Z0-9]{16}$/.test(u)){
   return {name:'UPS',detail:'UPS shipment',url:'https://www.ups.com/track?loc=en_US&tracknum='+encodeURIComponent(n)};
  }
  if(/^(92|93|94|95)[0-9]{18,20}$/.test(u)){
   return {name:'USPS',detail:'USPS shipment',url:'https://tools.usps.com/go/TrackConfirmAction?tLabels='+encodeURIComponent(n)};
  }
  return null;
 }
 function records(){
  try{
   var s=root.querySelector('[data-dhc-tracking-orders]');
   if(!s)return [];
   var x=JSON.parse(s.textContent)||[];
   return Array.isArray(x)?x:[];
  }catch(e){return [];}
 }
 var orderRecords=records();
 function addFact(list,k,v){if(!v)return;list.append(el('dt','',k),el('dd','',v));}
 function resultActions(orderUrl,carrierUrl){
  var row=el('div','dhc-tracking-result__actions');
  if(orderUrl&&orderUrl.charAt(0)==='/')row.append(link('View DHC order',orderUrl,false));
  if(carrierUrl){
   var a=link('View carrier details',carrierUrl,true);
   a.classList.add('dhc-tracking-link--primary');
   row.append(a);
  }
  return row;
 }
 function renderProvider(n,provider){
  box.replaceChildren();box.hidden=false;
  var head=el('div','dhc-tracking-result__head');
  head.append(
   el('span','dhc-tracking-result__eyebrow','TRACKING RESULT'),
   el('h3','',provider.detail),
   el('p','',provider.name==='Cainiao'
    ? 'We identified the likely carrier, but this page has not yet confirmed a physical carrier scan. You can use View carrier details to check the carrier record.'
    : 'We identified the likely carrier. Live scans appear here when the connected carrier feed confirms them; otherwise use View carrier details.')
  );
  box.append(head);
  var facts=el('dl','dhc-tracking-facts');
  addFact(facts,'Tracking number',n);
  addFact(facts,'Carrier',provider.name);
  addFact(facts,'DHC status','Carrier identified; live scan not yet verified');
  box.append(facts);
  box.append(resultActions('',provider.url));
 }
 function renderOrder(data,n,provider){
  box.replaceChildren();box.hidden=false;
  var status=(data.shipment_status||'').toLowerCase();
  var labels={confirmed:'Shipment confirmed',in_transit:'In transit',out_for_delivery:'Out for delivery',delivered:'Delivered',attempted_delivery:'Delivery attempted',failure:'Delivery exception'};
  var title=labels[status]||data.fulfillment_status||'Fulfillment update';
  var head=el('div','dhc-tracking-result__head');
  head.append(el('span','dhc-tracking-result__eyebrow','DHC ORDER UPDATE'),el('h3','',title),el('p','','Your available DHC fulfillment information is shown below. Carrier details are optional.'));
  box.append(head);
  var facts=el('dl','dhc-tracking-facts');
  addFact(facts,'Order',data.order_name);
  addFact(facts,'Tracking number',data.number||n);
  addFact(facts,'Carrier',provider?provider.name:data.carrier);
  addFact(facts,'Fulfillment',data.fulfillment_status);
  addFact(facts,'Shipment status',labels[status]||'Not reported by Shopify');
  addFact(facts,'Shopify update',date(data.updated_at));
  box.append(facts);
  var external=safeExternal(data.tracking_url);
  if(!external&&provider)external=provider.url;
  box.append(resultActions(data.order_url,external));
 }
 function direct17TrackUrl(n){
  return 'https://www.17track.net/en?nums='+encodeURIComponent(n);
 }
 function ensure17Track(){
  if(window.YQV5&&typeof window.YQV5.trackSingle==='function')return Promise.resolve(window.YQV5);
  if(dhc17TrackPromise)return dhc17TrackPromise;
  dhc17TrackPromise=new Promise(function(resolve,reject){
   var existing=document.querySelector('script[data-dhc-17track-script]');
   function ready(){
    if(window.YQV5&&typeof window.YQV5.trackSingle==='function')resolve(window.YQV5);
    else reject(new Error('17TRACK widget did not initialize'));
   }
   if(existing){
    if(window.YQV5&&typeof window.YQV5.trackSingle==='function'){resolve(window.YQV5);return;}
    existing.addEventListener('load',ready,{once:true});
    existing.addEventListener('error',function(){reject(new Error('17TRACK widget failed to load'));},{once:true});
    return;
   }
   var s=document.createElement('script');
   s.src='https://www.17track.net/externalcall.js';
   s.async=true;
   s.setAttribute('data-dhc-17track-script','1');
   s.onload=ready;
   s.onerror=function(){reject(new Error('17TRACK widget failed to load'));};
   document.head.appendChild(s);
  });
  return dhc17TrackPromise;
 }
 async function append17Track(n){
  var requestNumber=n.toUpperCase();
  var wrap=el('div','dhc-tracking-universal');
  wrap.append(el('div','dhc-tracking-result__eyebrow','17TRACK UNIVERSAL TRACKING'),el('h4','','Live carrier scans'));
  var status=el('p','dhc-tracking-universal__status','Detecting carrier and loading the latest available shipment events…');
  wrap.append(status);
  var host=el('div','dhc-17track-container');
  dhc17TrackSeq+=1;
  host.id='dhc17track-'+dhc17TrackSeq;
  wrap.append(host);
  box.append(wrap);
  try{
   var yq=await ensure17Track();
   if(String(input.value||'').trim().toUpperCase()!==requestNumber)return;
   status.textContent='17TRACK is checking its carrier network for this tracking number.';
   yq.trackSingle({
    YQ_ContainerId:host.id,
    YQ_Height:560,
    YQ_Fc:'0',
    YQ_Lang:'en',
    YQ_Num:n
   });
  }catch(e){
   status.textContent='Live embedded tracking is temporarily unavailable.';
   wrap.append(link('Track on 17TRACK',direct17TrackUrl(n),true));
  }
 }
 function renderUnknown(n){
  box.replaceChildren();box.hidden=false;
  var head=el('div','dhc-tracking-result__head');
  head.append(
   el('span','dhc-tracking-result__eyebrow','TRACKING LOOKUP'),
   el('h3','','Tracking number received'),
   el('p','','We are checking 17TRACK’s universal carrier network for this shipment. Carrier detection and live events will appear below when available.')
  );
  box.append(head);
  var facts=el('dl','dhc-tracking-facts');
  addFact(facts,'Tracking number',n);
  addFact(facts,'Carrier','Detecting automatically');
  box.append(facts);
  var row=el('div','dhc-tracking-result__actions');
  row.append(link('Open 17TRACK',direct17TrackUrl(n),true));
  var btn=el('button','dhc-tracking-gus-button','Ask Gus');
  btn.type='button';
  btn.setAttribute('data-dhc-gus-open','');
  btn.setAttribute('data-dhc-gus-context','tracking');
  btn.addEventListener('click',function(){
   var existing=document.querySelector('[data-dhc-gus-open],[data-dhc-jack-open]');
   if(existing&&existing!==btn)existing.click();
  });
  row.append(btn);
  box.append(row);
 }
 async function showVerifiedCarrierScan(n){
  if(!trackingApiUrl)return;
  try{
   var api=new URL(trackingApiUrl,location.href);
   var safeShopifyProxy=api.origin===location.origin&&/\/support-center\/?$/.test(api.pathname)&&api.searchParams.get('gus_endpoint')==='tracking';
   if(api.protocol!=='https:'||api.username||api.password||(!/\/api\/public-shipment\/?$/.test(api.pathname)&&!safeShopifyProxy))return;
   api.searchParams.set('tracking_number',n);
   var response=await fetch(api.href,{method:'GET',mode:'cors',credentials:'omit'});
   if(!response.ok)return;
   var evidence=await response.json();
   if(!evidence||evidence.verified!==true||!evidence.lastEventAt||String(input.value||'').trim().toUpperCase()!==n.toUpperCase())return;
   var facts=box.querySelector('.dhc-tracking-facts');if(!facts)return;
   var status=String(evidence.status||'').replaceAll('_',' ').toLowerCase();
   if(!status)return;
   addFact(facts,'Verified carrier update',status);
   addFact(facts,'Last carrier scan',date(evidence.lastEventAt));
   if(evidence.carrier)addFact(facts,'Verified carrier',evidence.carrier);
   var heading=box.querySelector('.dhc-tracking-result__head p');
   if(heading)heading.textContent='The carrier tracking feed confirms the update below. The carrier site has the full event history.';
  }catch(e){/* Keep the honest Shopify/carrier fallback if live evidence is unavailable. */}
 }
 function handle(n){
  var match=orderRecords.find(function(r){return String(r.number||'').trim().toUpperCase()===n.toUpperCase();});
  var provider=identify(n);
  if(match)renderOrder(match,n,provider);
  else if(provider)renderProvider(n,provider);
  else renderUnknown(n);
  void append17Track(n);
  void showVerifiedCarrierScan(n);
  try{box.scrollIntoView({behavior:'smooth',block:'nearest'});}catch(e){}
 }
 form.addEventListener('submit',function(e){
  e.preventDefault();
  var n=input.value.trim();
  if(!/^[A-Za-z0-9-]{5,50}$/.test(n)){
   box.replaceChildren(el('p','dhc-tracking-message','Enter a valid carrier tracking number. Order numbers are different from shipment tracking numbers.'));
   box.hidden=false;
   return;
  }
  if(submit){submit.disabled=true;submit.textContent='Checking…';}
  handle(n);
  if(submit)setTimeout(function(){submit.disabled=false;submit.textContent='Track Package';},350);
 });
 var params=new URLSearchParams(location.search);
 var n=params.get('tracking_number')||params.get('nums')||params.get('tracking')||params.get('trackingNumber')||params.get('number');
 if(n&&n.includes(','))n=n.split(',')[0].trim();
 if(n&&/^[A-Za-z0-9-]{5,50}$/.test(n)){input.value=n;handle(n);}
}
function start(){document.querySelectorAll('.dhc-track-retail').forEach(init);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
window.dhcTrackOrder=function(e){if(e)e.preventDefault();var f=document.querySelector('[data-dhc-tracking-form]');if(f)f.requestSubmit();};
})();